import React, {useState, useEffect, useContext} from "react";
import GenericDialog from '@common/GenericDialog';
import axios from "@common/axios";
import {BrandContext} from "@context/BrandContext"

const UserReviewConceptsDialog = props => {
    const {testResultId, open = false, handleClose} = props;
    const [reviewConcepts, setReviewConcepts] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const brandConfig = useContext(BrandContext);

    useEffect(() => {
        if (testResultId != null && testResultId != undefined) {
            setLoading(true);
            axios.get('/web/ui/test/findUserDiagnosticReviewConcepts', {params: {testResultId: testResultId}})
                .then(response => {
                    setReviewConcepts(response.data);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [testResultId]);

    return (
        <GenericDialog
            open={open}
            title="Diagnostic Feedback"
            buttons={[]}
            isLoading={isLoading}
            onClose={handleClose}>
            {reviewConcepts.length > 0 &&
                <div className={"ch-dashboard-blk-body"}>
                    <ul>
                        {reviewConcepts.map((reviewConcept, index) => (
                            <li key={index}>
                                <a href={"/lessonSection/loadConcept.action?topicId="+reviewConcept.topicId+"&conceptId="+reviewConcept.conceptId}>{reviewConcept.conceptName}</a>
                                &nbsp;-&nbsp;
                                {reviewConcept.questionSequences.map((seq, questionIndex) => (
                                    <span key={questionIndex}>Q{seq + 1}</span>
                                )).reduce((prev, curr) => [prev, ', ', curr])}
                            </li>
                        ))}
                    </ul>
                </div>
            }
            {reviewConcepts.length == 0 &&
                <div className={"disabled-message"}>There are no review {brandConfig.conceptsName.toLowerCase()} for this test.</div>
            }
        </GenericDialog>
    )
}

export default UserReviewConceptsDialog;